import React, {useEffect, useState} from 'react'
import {
  canvasToBlob,
  certificateLayout,
  CURRENT_CERTIFICATE_DESIGN,
  renderCertificate,
  type CertificateFormat,
  type CertificateLines,
} from './certificate-render'

export const CERTIFICATE_ASSET_BASE_URL = process.env.PUBLIC_URL ?? ''

type Props = {
  lines: CertificateLines
  format: CertificateFormat
  alt: string
  templateKey?: string
}

export const AasaCertificateImage: React.FC<Props> = ({lines, format, alt, templateKey}) => {
  const [src, setSrc] = useState('')
  const [failed, setFailed] = useState(false)
  const linesKey = JSON.stringify(lines)

  useEffect(() => {
    let cancelled = false
    let url = ''
    setFailed(false)
    renderCertificate({
      format,
      lines: JSON.parse(linesKey) as CertificateLines,
      templateKey,
      assetBaseUrl: CERTIFICATE_ASSET_BASE_URL,
    })
      .then((canvas) => canvasToBlob(canvas))
      .then((blob) => {
        if (cancelled) return
        url = URL.createObjectURL(blob)
        setSrc(url)
      })
      .catch(() => {
        if (!cancelled) setFailed(true)
      })
    return () => {
      cancelled = true
      if (url) URL.revokeObjectURL(url)
    }
  }, [format, linesKey, templateKey])

  const size = certificateLayout(templateKey || CURRENT_CERTIFICATE_DESIGN).formats[format]
  if (!src) {
    return (
      <div
        role='img'
        aria-label={alt}
        style={{
          aspectRatio: `${size.width} / ${size.height}`,
          width: '100%',
          display: 'grid',
          placeItems: 'center',
          background: '#FBF8F0',
          borderRadius: '0.375rem',
          color: '#78829d',
          fontSize: '13px',
        }}
      >
        {failed ? "The certificate couldn't be displayed." : null}
      </div>
    )
  }

  return (
    <img
      src={src}
      width={size.width * size.defaultScale}
      height={size.height * size.defaultScale}
      alt={alt}
      style={{width: '100%', height: 'auto', display: 'block', borderRadius: '0.375rem'}}
    />
  )
}
